export default __webpack_public_path__ + "static/media/main_level_test01_en.ec275c7e.png";